import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { Dashboard, Folder, People, Inventory, Gavel, ReceiptLong, Image } from '@mui/icons-material';

import { useMediaQuery } from '@mui/material';
import logoVexor from '../assets/logo-vexor.png';

function Sidebar({ onLogout }) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const menuItems = [
        { path: '/dashboard', label: 'Dashboard', icon: <Dashboard fontSize="small" /> },
        { path: '/projects', label: 'Projetos', icon: <Folder fontSize="small" /> },
        { path: '/clients', label: 'Clientes', icon: <People fontSize="small" /> },
        { path: '/products', label: 'Estoque', icon: <Inventory fontSize="small" /> },
        { path: '/manage-images', label: 'Imagens', icon: <Image fontSize="small" /> },
        { path: '/generate-legal', label: 'Jurídico', icon: <Gavel fontSize="small" /> },
        { path: '/generate-quote', label: 'Orçamento', icon: <ReceiptLong fontSize="small" /> },
    ];

    const handleLogout = () => {
        localStorage.removeItem('isAuthenticated');
        onLogout();
        navigate('/');
    };

    return (
        <div className="relative z-40">
            {/* Botão de menu (visível apenas em mobile) */}
            <button
                className="xl:hidden p-3 m-4 rounded-xl text-white bg-white/10 backdrop-blur-md border border-white/10 fixed top-0 left-0 z-50 hover:bg-white/20 transition-all"
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>

            {/* Backdrop para mobile */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 xl:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div
                className={`fixed top-0 left-0 h-screen w-64 text-white z-40 transition-transform transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
                    } xl:translate-x-0 xl:sticky bg-[#151c2c] border-r border-white/5 shadow-2xl flex flex-col`}
            >
                <div className="p-6 flex flex-col justify-between h-full">
                    {/* Título e Logo */}
                    <div className="mb-8 mt-4 xl:mt-0 px-2 flex items-center gap-3">
                        <img src={logoVexor} alt="Vexor Logo" className="w-10 object-contain" />
                        <div className="flex flex-col">
                            <span className="text-2xl font-bold tracking-widest text-gray-200 leading-none">VEXOR</span>
                            <span className="text-xs tracking-[0.2em] text-gray-400 font-light leading-tight mt-1">FINANCE</span>
                        </div>
                    </div>

                    {/* Navegação */}
                    <nav className="flex flex-col gap-2 flex-1 overflow-y-auto pr-2">
                        {menuItems.map((item) => {
                            const isActive = location.pathname.includes(item.path);
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    onClick={() => setIsOpen(false)}
                                    className={`relative py-3.5 px-4 rounded-xl transition-all text-base font-medium flex items-center gap-3 ${isActive
                                            ? 'bg-[#2a3449] text-white shadow-md'
                                            : 'text-gray-400 hover:bg-white/5 hover:text-gray-200'
                                        }`}
                                >
                                    {isActive && (
                                        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-6 bg-gradient-to-b from-purple-400 to-pink-500 rounded-r-md"></div>
                                    )}
                                    <span className={`${isActive ? 'text-white' : 'text-gray-400 group-hover:text-gray-300'}`}>
                                        {item.icon}
                                    </span>
                                    {item.label}
                                </Link>
                            );
                        })}
                    </nav>

                    {/* Botão Logout */}
                    <button
                        onClick={handleLogout}
                        className="mt-6 py-3 px-4 rounded-xl bg-red-500/20 text-red-300 hover:bg-red-500/40 hover:text-white border border-red-500/30 transition-all text-lg font-medium"
                    >
                        Sair da Conta
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
